module.exports = __webpack_public_path__ + "img/template-2.64870016.jpg";